import { Flex, FlexProps, Text } from '@mantine/core';
import {
	AcceptanceStatus,
	DocumentStatus,
	TransactionState,
} from '@dealstack/shared/lib/generated';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { getTranslationFromStatus } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/utils/investment.helper.ts';
import { EXPECTED_STATUS } from '@dealstack/shared/lib/common/business/kyc';
import {
	getColorFromStatus,
	getKycStatusColor,
	KycFileDisplayStatus,
	resolveStatusBadgeColors,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/utils/statusStyling.helper.ts';
import { StatusBadge } from '@dealstack/frontend/shared/components/StatusBadge/StatusBadge.tsx';

interface Props {
	name: string;
	status: DocumentStatus | AcceptanceStatus | TransactionState | KycFileDisplayStatus;
	direction?: FlexProps['direction'];
	isInherited?: boolean;
	isKyc?: boolean;
}

export const TextStatusRow = ({
	name,
	status,
	direction = 'row',
	isInherited,
	isKyc = false,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const { color, textColor } = resolveStatusBadgeColors(
		isKyc ? getKycStatusColor(status) : getColorFromStatus(status)
	);
	const getLabel = (): string | undefined => {
		if (isInherited) {
			return tMipManage('acceptance_status.inherited');
		}
		if (status === EXPECTED_STATUS) {
			return tMipManage('kyc_status.expected');
		}
		return getTranslationFromStatus(status, tMipManage);
	};
	const translatedStatus = getLabel();
	return (
		<Flex direction={direction} align="center" gap="0.25rem">
			<Text fw={400} c="dark.8" truncate lineClamp={1} style={{ wordBreak: 'break-all' }}>
				{name}
			</Text>
			{translatedStatus && (
				<StatusBadge text={translatedStatus} color={color} textColor={textColor} />
			)}
		</Flex>
	);
};
